import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api";

export const fetchFolderList = createAsyncThunk(
  "report/fetchFolderList",
  async () => {
    const response = await api.post("/get-folder-list");
    return response.data;
  }
);

export const deleteFolderList = createAsyncThunk(
  "report/deleteFolderList",
  async (payrollId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-payroll/${payrollId}`);
      dispatch(fetchFolderList());
      return response.data.message; // Success message from backend
    } catch (error) {
      return rejectWithValue(
        error.response?.data.message || "Failed to delete user"
      );
    }
  }
);

// Define the initial state and slice
const reportSlice = createSlice({
  name: "reportData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openPayrollModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closePayrollModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFolderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFolderList.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.loading = false;
      })
      .addCase(fetchFolderList.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch Folder List";
      })
      .addCase(deleteFolderList.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteFolderList.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteFolderList.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openPayrollModal, closePayrollModal, clearError } =
  reportSlice.actions;
export default reportSlice.reducer;
export { reportSlice };
